import { createApiService } from './createApiService'

export const adminAPI = createApiService({
  reducerPath: 'adminAPI',
  tagTypes: ['Users', 'Dashboard'],
  endpoints: (build: any) => ({
    getAllUsers: build.query({
      query: () => '/admin/users',
      providesTags: ['Users'],
    }),
    getUserById: build.query({
      query: (id: number) => `/admin/users/${id}`,
      providesTags: ['Users'],
    }),
    updateUserRole: build.mutation({
      query: ({ id, role }: { id: number; role: string }) => ({
        url: `/admin/users/${id}/role`,
        method: 'PATCH',
        body: { role },
      }),
      invalidatesTags: ['Users'],
    }),
    createUser: build.mutation({
      query: (userData: any) => ({
        url: '/admin/users',
        method: 'POST',
        body: userData,
      }),
      invalidatesTags: ['Users'],
    }),
    importImdbMovie: build.mutation({      
      query: (imdbId: string) => ({
        url: '/admin/import/imdb',
        method: 'POST',
        body: { imdbId },
      }),
      invalidatesTags: ['Users', 'Dashboard'],
    }),

    getDashboardStats: build.query({
      query: () => '/admin/dashboard',
      providesTags: ['Dashboard'],
    }),
  }),
})

export const {
  useGetAllUsersQuery,
  useGetUserByIdQuery,
  useUpdateUserRoleMutation,
  useGetDashboardStatsQuery,
  useCreateUserMutation,
  useImportImdbMovieMutation,
} = adminAPI